import { render, staticRenderFns } from "./app-detail.vue?vue&type=template&id=5c72d338&scoped=true&"
import script from "./app-detail.vue?vue&type=script&lang=ts&"
export * from "./app-detail.vue?vue&type=script&lang=ts&"
import style0 from "./app-detail.vue?vue&type=style&index=0&id=5c72d338&lang=scss&scoped=true&"
import style1 from "./app-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72d338",
  null
  
)

export default component.exports